import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "table-title"
}
const _hoisted_2 = { class: "data-table" }

import { computed } from "vue";
import { styleZoom } from "@/common/utils/style";


export default /*@__PURE__*/_defineComponent({
  __name: 'table-block',
  props: {
    block: {},
    selectedBlock: {},
    zoom: {}
  },
  emits: ["block:update"],
  setup(__props: any, { emit: __emit }) {

const emit = __emit;

const props = __props;

const columns = computed(() =>
  props.block.content?.columns?.filter((col: any) => !!col.visible)
);

const rows = computed(() =>
  props.block.content?.rows
    ?.filter((row: any) => !!row.visible)
    ?.filter((row: any) =>
      row.items.some((item: any) => {
        const col = columns.value.find((c: any) => c.id === item.col);
        return col && col.visible;
      })
    )
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["table-block", {
      selected: !!__props.selectedBlock,
    }]),
    style: _normalizeStyle(_unref(styleZoom)(__props.block.style, __props.zoom))
  }, [
    (__props.block.content?.title)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, _toDisplayString(__props.block.content?.title), 1))
      : _createCommentVNode("", true),
    _createElementVNode("table", _hoisted_2, [
      _createElementVNode("thead", null, [
        _createElementVNode("tr", null, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(columns.value, (col) => {
            return (_openBlock(), _createElementBlock("th", {
              key: col.id
            }, _toDisplayString(col.label), 1))
          }), 128))
        ])
      ]),
      _createElementVNode("tbody", null, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(rows.value, (row) => {
          return (_openBlock(), _createElementBlock("tr", {
            key: row.id
          }, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(row.items, (item) => {
              return (_openBlock(), _createElementBlock("td", {
                key: item.id
              }, _toDisplayString(item.value), 1))
            }), 128))
          ]))
        }), 128))
      ])
    ])
  ], 6))
}
}

})